import React from 'react';
import { PlanSelector } from './PlanSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function Oferta() {
  return <section id="oferta" className="bg-oferta-gradient px-5 py-10 md:py-[70px] text-center" data-id="element-166">
      <div className="mx-auto max-w-[820px]" data-id="element-167">
        <p className="mb-3 font-montserrat text-[11px] font-extrabold uppercase tracking-[3px] text-gold" data-id="element-168">
          Oferta de lanzamiento
        </p>
        <h2 className="mb-6 md:mb-10 font-bebas text-[clamp(30px,5vw,52px)] text-white" data-id="element-169">
          Elegí tu Kit Consultorio en Orden
        </h2>

        <UrgencyBanner data-id="element-170" />

        <PlanSelector showFeatures={true} data-id="element-171" />

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-172">
          {['✓ Pago seguro con Mercado Pago', '✓ Acceso en menos de 5 minutos', '✓ Garantía 7 días', '✓ PDF editable e imprimible'].map((trust, i) => <span key={i} className="font-montserrat text-[12px] font-medium text-white/50" data-id="element-173">
              {trust}
            </span>)}
        </div>
      </div>
    </section>;
}